module.exports = __webpack_public_path__ + "static/media/banner-4.220c0de9.jpeg";